import { BarChart3, ChevronRight, Clock, FileText, Settings, Video } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ScreenHeader } from '../components/layout/ScreenHeader';
import TransitionLink from '../components/TransitionLink';
import { useTransitionNavigate } from '../hooks/useTransitionNavigate';
import { useAuth } from '../store/auth.tsx';

const ProfilePage = () => {
  const { t } = useTranslation();
  const navigate = useTransitionNavigate();
  const location = useLocation();
  const { user, signOut } = useAuth();
  const from = (location.state as { from?: string } | null)?.from;
  const backTo = from && from !== '/profile' && !from.startsWith('/profile?') ? from : '/';

  const links = [
    { label: t('Аналитика'), to: '/analytics', icon: BarChart3, color: 'text-emerald-600', bg: 'bg-emerald-500/10' },
    { label: t('Все задачи'), to: '/tasks', icon: FileText, color: 'text-primary', bg: 'bg-primary-soft' },
    { label: t('Рабочие часы'), to: '/settings', icon: Clock, color: 'text-amber-600', bg: 'bg-amber-500/10' },
    { label: t('Ролики'), to: '/videos', icon: Video, color: 'text-violet-600', bg: 'bg-violet-500/10' },
    { label: t('Дополнительно'), to: '/settings/advanced', icon: Settings, color: 'text-slate-600', bg: 'bg-slate-500/10' },
  ];

  return (
    <div className="page-container max-w-lg">
      <ScreenHeader title={t('Профиль')} onBack={() => navigate(backTo)} backLabel={t('Назад')} />

      <div className="card flex items-center gap-4 p-6 mb-6">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-indigo-400 text-white flex items-center justify-center text-2xl font-bold shadow-glow">
          {user?.name?.charAt(0)}
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-bold text-slate-900 truncate">{user?.name}</h2>
          <p className="text-app-muted font-medium">{t('Коуч')}</p>
        </div>
      </div>

      <div className="grid gap-3 mb-6">
        {links.map((item) => {
          const Icon = item.icon;
          return (
            <TransitionLink
              key={item.to}
              to={item.to}
              className="card p-5 flex items-center gap-4 font-semibold text-slate-900 group"
            >
              <div className={`p-2.5 rounded-xl ${item.bg} ${item.color} transition-transform group-active:scale-95`}>
                <Icon size={20} />
              </div>
              <span className="flex-1">{item.label}</span>
              <ChevronRight size={18} className="text-slate-300" />
            </TransitionLink>
          );
        })}
      </div>

      <button
        type="button"
        className="btn-secondary w-full text-red-600 border-red-200 hover:bg-red-50"
        onClick={() => void signOut()}
      >
        {t('Выйти')}
      </button>
    </div>
  );
};

export default ProfilePage;
